import { useEffect } from 'react'

function StartLoading() {
    useEffect(()=>{
        const loader = document.getElementsByClassName('pageLoading')[0]
        const body = document.getElementsByTagName('body')[0]

        if(loader ) {
            loader.classList.add('show')
            body.classList.add('overflow-hidden')
        }

        return ()=>{
            loader && loader.classList.remove('show')
            body.classList.remove('overflow-hidden')
        }
    }, [])

  return (
    null
  )
}

export default StartLoading